import { useCallback, useRef } from 'react';

export const useDebounce = (callback: Function, delay: number) => {
  const timer = useRef<ReturnType<typeof setTimeout>>();

  const debouncedCallback = useCallback(
    (...args: any) => {
      timer.current && clearTimeout(timer.current);

      timer.current = setTimeout(() => {
        callback(...args);
      }, delay);
    },
    [callback, delay]
  );

  const clearDebouncedCallback = () => void clearTimeout(timer.current);
  return { debouncedCallback, clearDebouncedCallback };
};
